<iv-live-main-tab-panel></iv-live-main-tab-panel>

<ng-template tab-host></ng-template>

<div class="notification {{messageType}} {{messageActive}}">
  {{messageText}}
</div>
